import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { MessageSquare } from "lucide-react";

export default function SmsLog() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/sms/log").then((r) => setData(r.data)).catch(() => setData({ mode: "mock", items: [] })); }, []);
  return (
    <section className="space-y-3" data-testid="sms-log">
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex-1 min-w-[200px]"><p className="font-mono text-xs tracking-widest uppercase text-cyan-400">// Delivery SMS alerts</p><h3 className="font-display text-lg md:text-xl font-bold flex items-center gap-2"><MessageSquare className="w-4 h-4 text-cyan-400" />Text messages</h3></div>
        <span className={`px-2 py-0.5 rounded text-[10px] font-mono uppercase tracking-widest ${data?.mode === "live" ? "bg-emerald-500/20 text-emerald-300" : "bg-amber-500/20 text-amber-300"}`} data-testid="sms-mode">{data?.mode === "live" ? "Twilio live" : "Mock mode — add Twilio keys to send real texts"}</span>
      </div>
      <p className="text-xs text-slate-400">Customers who add a mobile number at checkout get a text when their order is confirmed, ships (with tracking link) and is delivered.</p>
      <div className="rounded-2xl border border-slate-800 bg-[#131722] divide-y divide-slate-800/60 max-h-72 overflow-y-auto" data-testid="sms-log-list">
        {data?.items?.length === 0 && <p className="px-4 py-4 text-sm text-slate-500" data-testid="sms-log-empty">No texts yet.</p>}
        {data?.items?.map((m, i) => (
          <div key={i} className="px-4 py-2.5 text-xs space-y-0.5" data-testid={`sms-item-${i}`}>
            <p className="font-mono text-slate-500">{new Date(m.at).toLocaleString()} · {m.to || m.raw_to} · {m.kind} · <span className={m.ok ? "text-emerald-300" : "text-rose-300"}>{m.ok ? (m.mode === "live" ? "sent" : "mock-sent") : `failed: ${m.error}`}</span></p>
            <p className="text-slate-300">{m.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
